/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { useNavigate, useParams } from 'react-router-dom';
import { useStandortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/useStandortgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { managerV1BaseUrl } from '@/utils';
import { createContext, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import {
  createRotationsplanFeatureStore,
  RotationsplanFeatureStore,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/store';
import { useRotationsplaene } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplaene/useRotationsplaene';
import { Page } from '@/domain/mitarbeiter/pages/rotationsplan/Page';
import { RotationsplanFeatureProvider } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { useBerufe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useBerufe/useBerufe';

// eslint-disable-next-line react-refresh/only-export-components
export const StoreContext = createContext<RotationsplanFeatureStore | null>(
  null,
);

const NavigateToV1 = () => {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <></>;
};

function validateRouteParam(view: string): boolean {
  const validViews: View[] = ['planung', 'rotationsplaene'];
  return validViews.includes(view as View);
}

export function PageWrapper() {
  const { t } = useTranslation();
  const { currentStandort, standorte } = useStandortContext();
  const standortIds = standorte.map((standort) => standort.id);
  const { standortGruppe } = useStandortgruppe(
    currentStandort?.idStandortgruppe,
  );
  const { rotationsplaene } = useRotationsplaene(standortIds);
  const { berufe } = useBerufe(standortGruppe.id);
  const { view, year } = useParams();
  const navigate = useNavigate();

  const store = useRef(
    createRotationsplanFeatureStore(
      rotationsplaene,
      berufe,
      standortGruppe.standorte,
      year,
    ),
  ).current;

  useEffect(() => {
    if ((!view || !validateRouteParam(view)) && !year) {
      const currentYear = dayjs(new Date()).get('year');
      navigate(`/mitarbeiter/rotationsplan/${currentYear}/planung`, {
        replace: true,
      });
    } else if (!view || !validateRouteParam(view)) {
      navigate(`/mitarbeiter/rotationsplan/${year}/planung`, {
        replace: true,
      });
    } else if (!year) {
      const currentYear = dayjs(new Date()).get('year');
      navigate(`/mitarbeiter/rotationsplan/${currentYear}/${view}`, {
        replace: true,
      });
    }
  }, [navigate, view, year]);

  if (!standortGruppe || !standortGruppe.istRotationsplanAktiviert) {
    return <NavigateToV1 />;
  }

  return (
    <>
      <Helmet>
        <title>{t('domain.mitarbeiter.rotationsplan.title')}</title>
      </Helmet>
      <StoreContext.Provider value={store}>
        <RotationsplanFeatureProvider>
          <Page year={year} view={view as View} />
        </RotationsplanFeatureProvider>
      </StoreContext.Provider>
    </>
  );
}
